import { render, staticRenderFns } from "./products-count-tag.vue?vue&type=template&id=32ff7184&"
import script from "./products-count-tag.vue?vue&type=script&lang=js&"
export * from "./products-count-tag.vue?vue&type=script&lang=js&"
import style0 from "./products-count-tag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ff7184')) {
      api.createRecord('32ff7184', component.options)
    } else {
      api.reload('32ff7184', component.options)
    }
    module.hot.accept("./products-count-tag.vue?vue&type=template&id=32ff7184&", function () {
      api.rerender('32ff7184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/products-count-tag.vue"
export default component.exports